import { Prediction, Station } from '../services/tides-service';
import { BaseModel } from './base-model';

export abstract class TidesModelBase extends BaseModel
{
    abstract getStations(): Promise<Station[]>;
    abstract getPredictionsRange(stationId: string, startDateUTC: string, endDateUTC: string) : Promise<Prediction[]>;
    abstract getPredictionsRangeWithInterval(stationId: string, startDateUTC: string, endDateUTC: string, interval: number): Promise<Prediction[]>;
    abstract getClosestStation(terminalId: string): Promise<Station>;
}

let TidesModel: TidesModelBase|null = null;

function setTidesModel(model: TidesModelBase)
{
    TidesModel = model;
}

export { TidesModel, setTidesModel };
